var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('button', {
    staticClass: "back-button-wrapper pointer",
    attrs: {
      "type": "button",
      "disabled": _vm.saving,
      "aria-label": "Zavrieť"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Upraviť údaje")])]), _c('client-details-form', {
    attrs: {
      "client": _vm.payload
    },
    on: {
      "busy": function busy($event) {
        _vm.saving = $event;
      },
      "saved": _vm.saved,
      "cancel": _vm.closePopup
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }